import { gridClasses, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import { DateTime } from "luxon";
import { padTime } from "../../util/dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../../util/timeZoneService";
import { isLWOPTOWOPAllDayRequest, isLWOPTOWOPDayOfRequest } from "../../util/timeOffRequestUtils";
import { Grid } from "@mui/material";
import { WOP_AUDIT_CURRENT_LIST } from "../../util/constants";
import PropTypes from "prop-types";

export default function AdminTimeOffRequestWOPToolbar(props) {
  const date = DateTime.now().setZone(getTimeZoneFromSwaStation(props.station));
  const formattedWopType = props.wopType;
  let fileName = `STARS_${props.station}_${formattedWopType}_${padTime(date.month)}-${padTime(date.day)}-${
    date.year
  }_${padTime(date.hour)}${padTime(date.minute)}`;
  if (props.currentAuditDateTimeSelection !== WOP_AUDIT_CURRENT_LIST) {
    fileName = fileName + `_Awarded_${props.currentAuditDateTimeSelection}`;
  }
  let columns = [
    "station",
    "referenceNumber",
    "timeOffRequestType",
    "visibleStatus",
    "submittedDate",
    "shift",
    "employeeId",
    "employee",
    "rank",
    "workgroup",
    "phoneNumber",
  ];

  if (isLWOPTOWOPAllDayRequest(props.wopType)) columns.push(...["beforeWOPDeadline"]);
  else if (isLWOPTOWOPDayOfRequest(props.wopType)) columns.push(...["preferredWOPLeaveTime", "approvedWOPLeaveTime"]);
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <Grid xs={12} sx={{ display: "flex", justifyContent: "space-between", margin: "5px" }}>
        <GridToolbarExport
          csvOptions={{ fileName: fileName, fields: columns }}
          printOptions={{ disableToolbarButton: true }}
        />
        {props.renderAuditSelect()}
      </Grid>
      
    </GridToolbarContainer>
  );
}

AdminTimeOffRequestWOPToolbar.propTypes = {
  station: PropTypes.string.isRequired,
  wopType: PropTypes.string.isRequired,
  renderAuditSelect: PropTypes.func.isRequired,
  currentAuditDateTimeSelection: PropTypes.string.isRequired,
};